import { styled, StyletronComponent, StyleObject } from 'styletron-react';

export const TableWrapper: StyletronComponent<any> = styled('div', {
    position: 'relative',
    height: '100%',
});

export const fixedPaginatorStyles = {
    position: 'absolute',
    right: '0',
    bottom: '0',
    left: '0',
} as StyleObject;
